module.exports = __webpack_public_path__ + "media/images/ribbon_ug_left-f338a3d8c330e95f3d3b8dc0c688c681.svg";